import { routeToProduct, getProductPriceTitle, formatProductTitle } from "@/helpers";
import { mapMutations } from "vuex";
import TypeSelect from "@/components/product/components/select/index.vue";

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  components: {
    TypeSelect,
  },
  data() {
    return {
      selectedProductPrice: this.product.productPrices.data[0],
    };
  },
  methods: {
    ...mapMutations({
      changeBasketPopup: "popups/CHANGE_BASKET_POPUP",
      changeLoginPopup: "popups/CHANGE_LOGIN_POPUP",
      addToBasket: `basket/ADD_ITEM_TO_BASKET`,
    }),
    routeToProduct,
    getProductPriceTitle,
    formatProductTitle,
    toProduct() {
      document.getElementById("html").classList.remove("hide");
      this.changeBasketPopup(false);
    },
    viewPrices() {
      this.changeLoginPopup(true);
      this.changeBasketPopup(false);
      document.getElementById("html").classList.remove("hide");
    },
    addBasket(product) {
      this.productsKey += 1;

      if (product.hasDuplicate) {
        this.$toasted.info(this.$t("Цей товар переміщено до нової серії"));
        return;
      }

      this.addToBasket({
        select_count: 1,
        product_price: this.selectedProductPrice,
        product: product,
      });
    },
    getLargeValue(products) {
      return products[0];
    },
  },
};
